export const REFERRERS = {
  AAFES: ['aafes.com', 'manh.com', 'shopmyexchange.com'],
  NEX: 'mynavyexchange.com',
  SS: ['suppliersolutions.com', 'catalogconnect.com'],
  WREN: ['wrenkitchens.com', 'wrenkitchens.us'],
};

export const LLC_ENVS = ['hd-qa74.homedepotdev.com'];